import { Box, BoxProps, CircularProgress, TypographyProps } from '@mui/material';
import { FC } from 'react';

interface LoadingPageSpinnerProps extends BoxProps {
    label?: string;
    labelProps?: TypographyProps;
}

const LoadingPageSpinner: FC<LoadingPageSpinnerProps> = ({ label, labelProps, ...props }) => {
    return (
        <Box
            {...props}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                ...props.sx,
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default LoadingPageSpinner;
